module.exports = __webpack_public_path__ + "static/media/default.fd187e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/carTrain/index/default.png
// module id = 1184
// module chunks = 0